import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getLoja, updateLoja, ILojaData } from "./services";

interface IStateConfigLoja {
  statusGet: "" | "success" | "failed" | "loading";
  statusUpdate: "" | "success" | "failed" | "loading";
  lojaData: ILojaData | null;
  feedbackError: string;
}

export const actionGetLojaConfig: any = createAsyncThunk(
  "GET_LOJA_CONFIG",
  async (id: number) => {
    const { data } = await getLoja(id);
    return data;
  },
);

export const actionUpdateLojaConfig: any = createAsyncThunk(
  "UPDATE_LOJA_CONFIG",
  async (data: ILojaData) => {
    const request = await updateLoja({ ...data });
    return request;
  },
);

const configLojaSlice = createSlice({
  name: "CONFIG_LOJA",
  initialState: <IStateConfigLoja>{
    statusGet: "",
    statusUpdate: "",
    lojaData: null,
    feedbackError: "",
  },
  reducers: {
    actionResetConfigLoja: (state) => {
      state.statusGet = "";
      state.statusUpdate = "";
      state.feedbackError = "";
    },
  },
  extraReducers: {
    [actionGetLojaConfig.pending]: (state) => {
      state.statusGet = "loading";
      state.feedbackError = "";
    },
    [actionGetLojaConfig.fulfilled]: (state, { payload }) => {
      console.log("REDUX GET LOJA PAYLOAD:", payload);
      state.statusGet = "success";
      state.lojaData = payload;
      state.feedbackError = "";
    },
    [actionGetLojaConfig.rejected]: (state, { error }) => {
      state.statusGet = "failed";
      state.feedbackError = error.message;
    },

    [actionUpdateLojaConfig.pending]: (state) => {
      state.statusUpdate = "loading";
      state.feedbackError = "";
    },
    [actionUpdateLojaConfig.fulfilled]: (state, { payload }) => {
      state.statusUpdate = "success";
      state.feedbackError = "";
    },
    [actionUpdateLojaConfig.rejected]: (state, { error }) => {
      state.statusUpdate = "failed";
      state.feedbackError = error.message;
    },
  },
});

export const { actionResetConfigLoja } = configLojaSlice.actions;
export default configLojaSlice.reducer;
